<script>
import DateRangeSelect from '@/components/DateRangeSelect';

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  methods: {
    handleDatesChange (dates) {
      this.$emit('change', {
        ...this.value,
        ...dates,
      });
    },
  },
  render () {
    const { minDate, maxDate } = this.value;

    return (
      <DateRangeSelect
        value={{ minDate, maxDate }}
        onChange={this.handleDatesChange}
      />
    );
  },
};
</script>
